module.exports = __webpack_public_path__ + "img/img-parts-sishu01-2.f84efbec.png";